import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-confirm-task-dialog',
	templateUrl: './confirm-task-dialog.component.html',
	styleUrls: ['./confirm-task-dialog.component.scss'],
})
export class ConfirmTaskDialogComponent {
	constructor() {}
}
